import React from "react";
import { NavLink, useHistory } from "react-router-dom";
import { NavItem } from "reactstrap";
import { withRouter } from "react-router-dom";
import { adminRole } from "../../constants/AppConstant";

class SideBarSubNav extends React.Component {
  state = {
    showDropdown: false,
  };

  toggleDropDown = () => {
    const showDropdown = !this.state.showDropdown;
    this.setState({ showDropdown });
    if (showDropdown) {
      const { navInfo, typeData: { walletCompany = 1, role = 1 } = {} } =
        this.props;
      let subModules = navInfo && navInfo.subModules;
      // if(walletCompany && role ==  adminRole.admin && navInfo.name == "Settings"){
      //     subModules = subModules.filter(module => module.name != "Manage Admins")
      // }
      const activeRoute = location && location.pathname;
      let activeUrl = subModules.filter((item) => item.link == activeRoute);
      if (activeUrl.length > 0) {
        activeUrl = activeUrl[0].link;
      } else {
        activeUrl = subModules[0].link;
      }
      this.props.history.replace({ pathname: activeUrl.toString() });
    }
  };

  subMenuClick = (e) => {
    e.stopPropagation();
    this.props.checkAccountIsLogin();
    this.setState({ showDropdown: true });
  };

  componentDidMount() {
    // this.state.showDropdown === true && this.nevigate()
  }

  nevigate = () => {
    let newURL = "/admin/accounts/manage-admins";
    const activeRoute = location && location.pathname;
    activeRoute !== newURL
      ? (window.location = "/admin/accounts/manage-admins")
      : null;
  };
  getSubModules = () => {
    const { activeIntegration } = this.props;

    const navInfo = this.props && this.props.navInfo;
    let subModules = navInfo && navInfo.subModules;
    const walletCompany =
      this.props && this.props.typeData && this.props.typeData.walletCompany;
    const accessRole =
      this.props && this.props.typeData && this.props.typeData.role;
    let subModuleArray = [];
    // if(walletCompany && accessRole ==  adminRole.admin && navInfo.name == "Settings"){
    //     subModules = subModules.filter(module => module.name != "Manage Admins")
    // }
    const activeRoute = location && location.pathname;
    subModuleArray.push(
      subModules.map((subModule, index) => {
        return (
          <>
            <NavLink
              onClick={this.subMenuClick}
              to={subModule.link}
              activeClassName={activeRoute == subModule.link ? "active" : ""}
              className={"nav-link sidebar-sub"}
              key={`subNav${index}`}
            >
              {subModule.icon ? (
                <span>
                  <img
                    src={subModule.icon}
                    style={{ width: "30px", height: "30px" }}
                  />
                  <span>&nbsp;&nbsp;</span>
                </span>
              ) : (
                <span style={{ height: "20px", width: "20px" }}>&nbsp;</span>
              )}
              <span style={{ textTransform: "capitalize" }}>
                {subModule.name}
              </span>
            </NavLink>
            {/*
                this.state.showDropdown === true && index === 0 && activeRoute !== subModule.link ?   <Switch>
                    <Redirect exact  to={subModule.link}  />
                          
                </Switch> : null */}
          </>
        );
      })
    );
    return subModuleArray;
  };

  render() {
    const superAdminRole =
      this.props && this.props.typeData && this.props.typeData.role;
    const navInfo = this.props && this.props.navInfo;
    const { showDropdown } = this.state;
    const activeRoute = location && location.pathname;
    return (
      <>
        <NavItem
          onClick={() => {
            this.toggleDropDown();
          }}
        >
          <a className="nav-link xx">
            <span>
              <navInfo.icon />
            </span>
            <span>{navInfo.name}</span>
            <span>
              {/*
                                // (activeRoute.includes(navInfo.link) || showDropdown)
                                showDropdown
                                    ? 
                                <i className="fa fa-angle-up float-right " aria-hidden="true"></i> :
                                <i className="fa fa-angle-down float-right" aria-hidden="true"></i>
                            */}
            </span>
          </a>
          {
            // (activeRoute.includes(navInfo.link) || showDropdown)
            showDropdown ? this.getSubModules() : null
          }
        </NavItem>
      </>
    );
  }
}

export default withRouter(SideBarSubNav);
